import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-8",
  "use": "menu-8-usage",
  "viewBox": "0 0 109 109",
  "content": "<symbol viewBox=\"0 0 109 109\" id=\"menu-8\"><title>资源 107</title><g id=\"menu-8_图层_2\" data-name=\"图层 2\"><g id=\"menu-8_图层_1-2\" data-name=\"图层 1\"><path d=\"M4.36,95.92H33.79V50.14l-8.18-5.45L4.36,62.13Zm36,0H69.76V50.14L55.59,61.58,40.33,54Zm36-51.23V95.92h29.43V45.23L93.2,29.43Z\" /><path d=\"M8.72,49.6l15.8-13.08L55,54.5,91,21.25l.54-.54,6,6L107.37,0,79.57,8.72l6.54,6.54L54.5,44.69,24,27.25,3.82,43.6c-1.64,1.09-1.64,3.81-.54,5.45S7.08,50.69,8.72,49.6Z\" /><path d=\"M105.18,101.37H3.82a3.81,3.81,0,1,0,0,7.63H105.19a3.82,3.82,0,0,0,0-7.63Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-8.svg
// module id = WxB6
// module chunks = 264